import { useState } from "react";
import { AlertTriangle, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { usePaymentUpdateDialog } from "@/contexts/PaymentUpdateDialogContext";
import { createPaymentUpdatePortalSessionFunction } from "@/data/firebase";

export function PaymentUpdateDialog() {
  const { isPaymentUpdateOpen, closePaymentUpdate } = usePaymentUpdateDialog();
  const [isLoading, setIsLoading] = useState(false);

  const handleUpdatePayment = async () => {
    try {
      setIsLoading(true);
      const { data } = await createPaymentUpdatePortalSessionFunction({
        returnUrl: window.location.href,
      });

      // Use type assertion to handle the response
      const responseData = data as { url?: string };
      if (responseData.url) {
        window.location.href = responseData.url;
      } else {
        throw new Error("Invalid response from payment portal");
      }
    } catch (error) {
      console.error("Failed to create payment update portal session:", error);
      alert(
        "Failed to create payment update portal session, please contact support"
      );
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 1000);
    }
  };

  return (
    <Dialog open={isPaymentUpdateOpen} onOpenChange={closePaymentUpdate}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader className="flex flex-col items-center gap-2">
          <AlertTriangle className="h-12 w-12 text-red-500" />
          <DialogTitle className="text-center">
            Payment Method Failed
          </DialogTitle>
          <DialogDescription className="text-center">
            Your payment method requires an update to continue using Options AI.
            Please update your payment details to restore full access.
          </DialogDescription>
        </DialogHeader>

        <DialogFooter>
          <Button
            variant="destructive"
            className="w-full"
            onClick={handleUpdatePayment}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Processing...
              </>
            ) : (
              "Update Payment Method"
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
